import { toLower } from 'lodash';
import styles from './AppMatchInfo.module.scss';
import { useTranslation } from 'next-i18next';
import { Col, Collapse, Row } from 'antd';
import classNames from 'classnames';
import { UpOutlined } from '@ant-design/icons';
import { useState } from 'react';
const { Panel } = Collapse;

type collapseTypes = {
    [key: string]: boolean;
};

const AppMatchInfo = ({ routerPath, content }: any) => {
    const { t } = useTranslation();
    const [collapsed, setCollapsed] = useState({
        Leagues: true,
        Cups: true,
        Internationals: true,
        Others: true,
    } as collapseTypes);
    const targenItems = (targets: any) => {
        const name = targets.name;
        return (
            <>
                <Collapse
                    className={classNames(
                        { panelOpend: !collapsed[name] },
                        styles['match-info-collapse']
                    )}
                    expandIcon={({ isActive }) => <UpOutlined rotate={isActive ? 0 : 180} />}
                    expandIconPosition='end'
                    defaultActiveKey={[name]}
                    ghost
                    onChange={() =>
                        setCollapsed(Object.assign(collapsed, { name: !collapsed[name] }))
                    }
                >
                    <Panel
                        header={
                            <div className={styles['title-content']}>
                                <span className={styles['text-title']}>
                                    {t(`MatchInfo.${name}`)}
                                </span>
                            </div>
                        }
                        key={name}
                    >
                        {
                            <Row className={styles['tournament-info']} gutter={16}>
                                {targets.targetItems.map((t: any, n: number) => {
                                    return t?.tournamentName?.value ? (
                                        <Col
                                            className={styles['item']}
                                            sm={12}
                                            md={6}
                                            xs={12}
                                            key={t?.tournamentCode?.value || n}
                                        >
                                            {t?.tournamentIcon?.src && (
                                                <img
                                                    src={t?.tournamentIcon?.src}
                                                    alt={t?.tournamentName?.value}
                                                />
                                            )}
                                            {t?.tournamentName?.value}
                                        </Col>
                                    ) : (
                                        ''
                                    );
                                })}
                            </Row>
                        }
                    </Panel>
                </Collapse>
            </>
        );
    };

    const ItemEnabled = (enabled: any) => {
        return enabled?.value === '1';
    };
    return (
        <div className={`${styles.container}`}>
            {ItemEnabled(content.leaguesEnabled) && targenItems(content.leagues)}
            {ItemEnabled(content.cupsEnabled) && targenItems(content.cups)}
            {ItemEnabled(content.internationalsEnabled) && targenItems(content.internationals)}
            {ItemEnabled(content.othersEnabled) && targenItems(content.others)}
        </div>
    );
};

export default AppMatchInfo;
